import './PlanPassFailTask.style.less'

// import { ITaskTemplate } from '../../../../../../../../TaskTemplate.interface'
import PlanTaskLayout from '../../Layouts/PlanTaskLayout'

interface Prop {
  data: any
}

export function PlanPassFailTask(prop: Prop) {
  return <PlanTaskLayout data={prop.data} planLabel={`Plan`} />
}

export default PlanPassFailTask
